import React from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

import thumbnail from 'images/landing/aio_video_poster.jpg';


const Video = () => {
  return (
    <div className="video">
      <LiteYouTubeEmbed
        id="bYhRhDvTP5c"
        title="Adafruit IO Video"
        poster="maxresdefault"
        thumbnail={thumbnail}
      />
    </div>
  );
};

export default Video;
